import { ICoordinateStore } from './types';

const initStore: ICoordinateStore = {
  activeChannelId: null,
  channels: [],
  channelsLoading: false,
  current: null,
  messages: {},
  relatedTeamMembers: [],
};

export default initStore;
